{#if $isUserLoggedIn}
  <TimelineHomePage/>
{:else}
  <NotLoggedInHome/>
{/if}
<script>
  import NotLoggedInHome from '../_components/NotLoggedInHome.html'
  import { store } from '../_store/store.js'
  import TimelineHomePage from '../_components/TimelineHomePage.html'
  import { observe } from 'svelte-extras'
  import { doQuickLoginIfNecessary } from '../_actions/doQuickLoginIfNecessary.js'

  export default {
    async oncreate () {
      doQuickLoginIfNecessary()
    },
    store: () => store,
    methods: {
      observe
    },
    components: {
      NotLoggedInHome,
      TimelineHomePage
    }
  }
</script>
